import { useAppStore } from "@/store/store";
import { useActiveLocationTimezone } from "@/hooks/use-locations";
import { todayStr } from "@/utils/date";
import OnTheBooksReport from "./OnTheBooksReport";
import ServiceRecapReport from "./ServiceRecapReport";

/** Day-report tab on /reservas. The dashboard splits along the date axis:
 *  ``selectedDate < today`` → ``ServiceRecapReport`` (post-service KPIs
 *  for finance/ops review); ``selectedDate >= today`` → ``OnTheBooksReport``
 *  (pacing, kitchen-cap headroom, restrictions to prep). */
export default function DayReportView() {
  const selectedDate = useAppStore((s) => s.selectedDate);
  const tz = useActiveLocationTimezone();
  const today = todayStr(tz);
  const isPast = selectedDate < today;
  return isPast ? <ServiceRecapReport /> : <OnTheBooksReport />;
}
